import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/header';
import Footer from '../components/footer';

const Login = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow flex items-center justify-center bg-gray-50 py-16">
        <div className="max-w-md w-full mx-auto px-4">
          <div className="bg-white rounded-lg shadow-lg p-8 text-center">
            {/* Under Development Icon */}
            <div className="mb-6">
              <div className="mx-auto w-24 h-24 bg-yellow-100 rounded-full flex items-center justify-center mb-4">
                <svg className="w-12 h-12 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.732 15.5c-.77.833.192 2.5 1.732 2.5z" />
                </svg>
              </div>
              <h1 className="text-3xl font-bold text-gray-900 mb-2 font-montserrat">
                Login Page
              </h1>
              <h2 className="text-xl text-yellow-600 font-semibold mb-4 font-montserrat">
                Under Development
              </h2>
            </div>

            {/* Message */}
            <div className="mb-8">
              <p className="text-gray-600 text-lg mb-4 font-open-sans">
                We're currently working on our login system to provide you with a secure and seamless experience.
              </p>
              <p className="text-gray-500 font-open-sans">
                This page will be available soon. Thank you for your patience!
              </p>
            </div>

            {/* Contact Information */}
            <div className="mb-8 p-4 bg-blue-50 rounded-lg">
              <p className="text-sm text-gray-700 mb-2 font-open-sans">
                Need immediate assistance?
              </p>
              <div className="flex flex-col sm:flex-row gap-2 justify-center">
                <a 
                  href="mailto:info@medicallinkers.com"
                  className="text-blue-600 hover:text-blue-800 text-sm font-medium font-open-sans"
                >
                  info@medicallinkers.com
                </a>
                <span className="hidden sm:inline text-gray-400">|</span>
                <a 
                  href="https://api.whatsapp.com/send/?phone=9599222655&text=Hello%2C+I+need+assistance+with+login&type=phone_number&app_absent=0"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-green-600 hover:text-green-800 text-sm font-medium font-open-sans"
                >
                  WhatsApp Support
                </a>
              </div>
            </div>

            {/* Return to Home Button */}
            <div className="space-y-3">
              <Link
                to="/"
                className="w-full bg-[#1976f2] text-white px-6 py-3 rounded-full font-semibold hover:bg-blue-600 transition-colors inline-block font-montserrat"
              >
                Return to Home Page
              </Link>
              
              {/* Additional Navigation */}
              <div className="text-sm text-gray-500 font-open-sans">
                or explore our{' '}
                <Link to="/hospitals" className="text-blue-600 hover:text-blue-800 font-medium">
                  Hospitals
                </Link>
                {' '}and{' '}
                <Link to="/doctors" className="text-blue-600 hover:text-blue-800 font-medium">
                  Doctors
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Login;
